import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import LoadingButton from "../common/LoadingButton";

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, surname, email, phone, message } = formData;

    const subject = encodeURIComponent("New Contact Form Submission");
    const body = encodeURIComponent(
      `Name: ${name} ${surname}\nEmail: ${email}\nPhone: ${phone}\n\nMessage:\n${message}`
    );

    window.location.href = `mailto:biuro@goatskarate.pl?subject=${subject}&body=${body}`;
};

  return (
    <div className="contact-section">
      <h3 className="contact-title">📬 {t("contact.form.title")}</h3>
      <form onSubmit={handleSubmit} className="contact-form">
        <input type="text" name="name" placeholder={t("contact.form.name")} value={formData.name} required onChange={handleChange} />
        <input type="text" name="surname" placeholder={t("contact.form.surname")} value={formData.surname} required onChange={handleChange} />
        <input type="email" name="email" placeholder={t("contact.form.email")} value={formData.email} required onChange={handleChange} />
        <input type="tel" name="phone" placeholder={t("contact.form.phone")} value={formData.phone} onChange={handleChange} />
        <textarea
          name="message"
          placeholder={t("contact.form.message")}
          value={formData.message}
          onChange={handleChange}
          rows={4}
          required
        />
        <LoadingButton type="submit">
          {t("contact.form.submit")}
        </LoadingButton>
      </form>
    </div>
  );
};

export default ContactForm;
